export const errorMessages = [
  {
    code: 404,
    props: {
      pageTitle: "Content not found",
      pageHeading: "404 content not found",
      pageCopy: "Looks like the content you're after has left the pitch.",
      navigate: "/",
      errorImage: undefined,
    },
  },
  {
    code: 500,
    props: {
      pageTitle: "Server Error",
      pageHeading: "500 Server Error",
      pageCopy: "Oops, something went wrong. Our team can help work out what's going on.",
      navigate: "mailto:support@manvfat.com",
      errorImage: undefined,
    },
  },
  {
    code: 403,
    props: {
      pageTitle: "No access",
      pageHeading: "403 Forbidden",
      pageCopy:
        "Looks like you don't have the right permissions to access this area. Our team can help you get back into The Dugout ",
      navigate: "mailto:support@manvfat.com",
      errorImage: undefined,
    },
  },
  {
    code: 401,
    props: {
      pageTitle: "Authorisation Error",
      pageHeading: "401 Unauthorised",
      pageCopy:
        "Looks like you don't have the right permissions to access this area. Our team can help you get back into The Dugout ",
      navigate: "mailto:support@manvfat.com",
      errorImage: undefined,
    },
  },
];
